const ITEMS = [
    "Instant Lead Response",
    "Missed-Call Text-Back",
    "Automatic Appointment Booking",
    "24/7 Follow-Up",
    "Review Requests",
    "Lead Reactivation",
    "Never Miss Another Customer",
];

export default function Marquee() {
    return (
        <div className="border-y border-white/5 py-6 overflow-hidden" data-testid="marquee">
            <div className="marquee-track flex items-center gap-14 whitespace-nowrap">
                {[...ITEMS, ...ITEMS].map((t, i) => (
                    <span key={i} className="flex items-center gap-14 ff-display text-lg sm:text-xl font-semibold text-slate-600">
                        {t}
                        <span className="w-1.5 h-1.5 rotate-45 bg-cyan-500/50 inline-block" />
                    </span>
                ))}
            </div>
        </div>
    );
}
